import MembershipCard from "components/MembershipCard";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import { IWorkspaceMember } from "dto/IWorkspace";
import AddWorker from "components/Settings/AddWorker";
import { useEffect, useState } from "react";
import Input from "components/Input";
import { useTranslation } from "react-i18next";

const WorkspaceMembers: FC<Props> = ({
  workspace,
  showAdd,
  setShowAdd,
  refetch,
  myPrivilages,
  roles,
  members,
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const [workspaceName, setWorkspaceName] = useState(workspace.Name);

  const [showMembers, setShowMembers] = useState(members);

  useEffect(() => {
    if (searchValue.length > 0) {
      const searchedWorkers = members.filter(
        (worker) =>
          worker.Label.toLocaleLowerCase().search(
            searchValue.toLocaleLowerCase()
          ) !== -1
      );
      setShowMembers(searchedWorkers);
      return;
    }

    setShowMembers(members);
  }, [searchValue]);

  useEffect(() => {
    setSearchValue("");
    setShowMembers(members);
  }, [members]);

  useEffect(() => {
    setWorkspaceName(workspace?.Name);
  }, [workspace]);

  return (
    <>
      <div className={styles.group}>
        <div className={styles.title}>{t("workspace.yourTeam")}</div>
        <div className={styles.hint}>
          {t("workspace.teamDescription")}
        </div>
      </div>
      <div className={styles.wrap}>
        <div className={styles.search}>
          <Input
            label={t("workspace.teamName")}
            value={workspaceName}
            defaultValue={t("workspace.teamName")}
            onChange={(v) => setWorkspaceName(v)}
            onRightText={t("workspace.inviteToTeam")}
            onRightClick={
              myPrivilages.CanInviteMembersToWorkspace
                ? () => setShowAdd(true)
                : undefined
            }
            hideClearButton={true}
            className={styles.nameInput}
            noBackground={true}
          />
        </div>

        <div className={styles.list}>
          {showMembers
            .sort((a, b) => {
              if (a.IsMe && !b.IsMe) return -1;
              if (!a.IsMe && b.IsMe) return 1;

              if (a.IsMe === b.IsMe) {
                if (a.Status === 0 || b.Status === 0) {
                  return a.Status - b.Status;
                }

                const statusOrder = [0, 1, 4, 2, 3];
                const statusComparison =
                  statusOrder.indexOf(a.Status) - statusOrder.indexOf(b.Status);

                if (statusComparison === 0) {
                  return a.Label.localeCompare(b.Label);
                }

                return statusComparison;
              }

              return 0;
            })
            .map((worker: IWorkspaceMember) => (
              <MembershipCard
                key={worker.Id}
                structure={workspace.Structure}
                myPrivilages={myPrivilages}
                refetch={refetch}
                roles={roles}
                worker={worker}
                workspace={workspace}
                members={members}
              />
            ))}
        </div>
        {showAdd && (
          <AddWorker
            roles={roles}
            structure={workspace.Structure}
            toggle={() => setShowAdd(false)}
            refetch={refetch}
            workspaceId={workspace.Id}
          />
        )}
      </div>
    </>
  );
};

export default WorkspaceMembers;
